// extracted by mini-css-extract-plugin
module.exports = {"mail-page__main-block":"main-block_mail-page__main-block__2hKBz"};